import LazyLoad from "react-lazyload";
import { Link } from 'react-router-dom'
const UniqueIdentity = () => { 
  return (
    <>
      <div className="breadcrumb">
        <h2>Unique Identity</h2>
        <ul>
          <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
          <li>|</li>
                    <li>Features</li>
                    <li>|</li>
          <li>Unique Identity</li>
        </ul>
      </div>
      <div className="inner_page">
        <div className="container">
            <div className="row">
                <div className="col-md-4">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/identify.jpg" alt="st francis school, Amritsar" className="img-fluid bordered_img" /></LazyLoad>
                </div>
                <div className="col-md-8"> 
                    <h3 className="heading">Unique Identity</h3>
                    <p>To create the spirit of competition and co-operation among the students the entire school is divided into 4 houses namely <span>Alverna, Assisi, Greccio, Umbria</span>. This indeed inculcates sportsmanship and develops healthy competition among the students.</p>
                    <p>The management always keep in mind the need for forming good leaders by providing them opportunities to develop their talents. The school cabinet is elected to assist the principal and the staff in the efficient running for the school at the beginning of the academic year. The election is held on the basis of all round proficiency and qualities of health and leadership through a process of nomination and election. The elected candidates are then formally commissioned during a colourful investiture ceremony and they are distinguished from others by their badges and sashes.</p>
                   
                </div> 
            </div>
        </div>
      </div>
    </>
  )
}

export default UniqueIdentity
